import React from "react";

import styles from "./votes-listing.module.css";
import layout from "../layout.module.css";

let toLi = (fnIdx, rationales) => (v) => {
  let fnLink = v.rationale ? (
    <a href={`#fn${fnIdx.val}`} className={styles.footnoteLink}>
      [why?]
    </a>
  ) : null;

  if (fnLink) {
    rationales.push({ voter: v.voter, rationale: v.rationale, idx: fnIdx.val });
    fnIdx.inc();
  }

  return (
    <li key={v.voter}>
      {v.voter}
      {fnLink}
    </li>
  );
};

let VotesListing = ({ game, votes }) => {
  let fnIdx = {
    val: 1,
    inc() {
      this.val++;
    },
  };
  let rationales = [];

  return (
    <div className={styles.resultsSection}>
      <h2 className={styles.results} id="votes-listing">
        Results:
      </h2>
      <div className={layout.container}>
        <div className={layout.left}>
          <p className={styles.resultsOwner}>
            {game.teamA ? game.teamA.owner : "TBD"} {game.teamA && "("}
            {votes[game.teamA && game.teamA.owner] &&
              votes[game.teamA.owner].length}
            {game.teamA && ")"}
          </p>
          <ul className={styles.votes}>
            {votes[game.teamA && game.teamA.owner] &&
              votes[game.teamA.owner].map(toLi(fnIdx, rationales))}
          </ul>
        </div>
        <div className={layout.right}>
          <p className={styles.resultsOwner}>
            {game.teamB ? game.teamB.owner : "TBD"} {game.teamB && "("}
            {votes[game.teamB && game.teamB.owner] &&
              votes[game.teamB.owner].length}
            {game.teamB && ")"}
          </p>
          <ul className={styles.votes}>
            {votes[game.teamB && game.teamB.owner] &&
              votes[game.teamB.owner].map(toLi(fnIdx, rationales))}
          </ul>
        </div>
      </div>
      {rationales.map((r) => {
        let rId = `fn${r.idx}`;
        return (
          <div id={rId} key={rId} className={styles.vote}>
            <h5 className={styles.voterLabel}>{r.voter}:</h5>
            {r.rationale}
            <a href="#votes-listing">⤴</a>
          </div>
        );
      })}
    </div>
  );
};

export default VotesListing;
